"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useIntl;
var _react = require("react");
var _intlProvider = require("./intl-provider.js");
var _formattedMessage = require("./formatted-message.js");
/**
 * Custom React hook for internationalization (i18n) that provides
 * a method to format messages based on the provided id and values.
 *
 * This hook uses the context provided by PolyfillReactIntl to access
 * the messages and provides a method to format messages.
 *
 * @returns {Object} An object containing the formatMessage function.
 * @returns {Function} formatMessage - Function to format messages.
 * @returns {string} formatMessage.id - The id of the message to format.
 * @returns {Object} formatMessage.values - The values to interpolate into the message.
 * @returns {string} formatMessage - The formatted message.
 */
function useIntl() {
  var _useContext = (0, _react.useContext)(_intlProvider.PolyfillReactIntl),
    messages = _useContext.messages;

  /**
   * Formats a message based on the provided id and values.
   *
   * @param {Object} messageDescriptor - The descriptor of the message.
   * @param {string} messageDescriptor.id - The id of the message to format.
   * @param {string} messageDescriptor.defaultMessage - The fallback message id to format.
   * @param {Object} values - The values to interpolate into the message.
   * @returns {string} The formatted message.
   */
  function formatMessage(messageDescriptor, values) {
    return (0, _formattedMessage.getMessage)(messageDescriptor, values, messages);
  }
  return {
    formatMessage: formatMessage,
    messages: messages
  };
}